import { item as item_1, truncate, length, singleton as singleton_1, append as append_1, filter, contains, indexed, choose, exists, tryFindIndex, tail, head, map, isEmpty, ofArray, empty, cons, reverse } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { replace, split, join } from "../fable_modules/fable-library-js.4.28.0/String.js";
import { item } from "../fable_modules/fable-library-js.4.28.0/Array.js";
import { ImportStep, ColumnMapping } from "../Pages/Event/State.js";
import { createElement } from "react";
import { equals, numberHash, int32ToString, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { tryParse } from "../fable_modules/fable-library-js.4.28.0/Int32.js";
import { FSharpRef } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { empty as empty_1, map as map_1, collect, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { ta, t as t_1 } from "../Lang.js";
import { Import_stepImport, Import_stepMap, Import_stepUpload, Import_cancel, Import_title, Import_totalGuests, Import_bulkTagsPlaceholder, Import_bulkTagsLabel, Import_swapNames, Enum_Gender_nonbinary, Enum_Gender_female, Enum_Gender_male, Import_genderUnspecified, Import_importButton, Import_importing, Import_totalRows, Import_previewRows, Import_step3, Import_back, Guests_notes, Guests_tags, Guests_dietaryTags, Guests_dietary, Guests_title, Guests_age, Guests_gender, Guests_lastName, Guests_firstName, Import_step2, Import_cloneButton, Import_cloning, Import_cloneIncludeRelationships, Import_cloneNoEvents, Import_cloneSelectEvent, Import_cloneDivider, Import_detectedGuests, Import_pastePlaceholder, Import_pasteDivider, Import_next, Import_detectedColumns, Import_uploadPrompt, Import_step1, Import_unmapped } from "../Shared/Tr.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Msg } from "../App/Messages.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { badge } from "./Components.js";
import { Gender, GenderModule_toInt } from "../Shared/Types.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.28.0/Range.js";

function parseCsvLine(line) {
    const chars = line.split("");
    const len = chars.length | 0;
    const loop = (i_mut, inQuotes_mut, acc_mut, fields_mut) => {
        loop:
        while (true) {
            const i = i_mut, inQuotes = inQuotes_mut, acc = acc_mut, fields = fields_mut;
            if (i >= len) {
                return reverse(cons(join("", reverse(acc)), fields));
            }
            else {
                const c = item(i, chars);
                if (inQuotes) {
                    if (c === "\"") {
                        if (((i + 1) < len) && (item(i + 1, chars) === "\"")) {
                            i_mut = (i + 2);
                            inQuotes_mut = true;
                            acc_mut = cons("\"", acc);
                            fields_mut = fields;
                            continue loop;
                        }
                        else {
                            i_mut = (i + 1);
                            inQuotes_mut = false;
                            acc_mut = acc;
                            fields_mut = fields;
                            continue loop;
                        }
                    }
                    else {
                        i_mut = (i + 1);
                        inQuotes_mut = true;
                        acc_mut = cons(c, acc);
                        fields_mut = fields;
                        continue loop;
                    }
                }
                else {
                    switch (c) {
                        case "\"": {
                            i_mut = (i + 1);
                            inQuotes_mut = true;
                            acc_mut = acc;
                            fields_mut = fields;
                            continue loop;
                        }
                        case ",": {
                            i_mut = (i + 1);
                            inQuotes_mut = false;
                            acc_mut = empty();
                            fields_mut = cons(join("", reverse(acc)), fields);
                            continue loop;
                        }
                        default: {
                            i_mut = (i + 1);
                            inQuotes_mut = false;
                            acc_mut = cons(c, acc);
                            fields_mut = fields;
                            continue loop;
                        }
                    }
                }
            }
            break;
        }
    };
    return loop(0, false, empty(), empty());
}

function parseCsv(content) {
    const lines = ofArray(split(content, ["\n", "\r"], undefined, 1));
    if (!isEmpty(lines)) {
        return [map((s) => s.trim(), parseCsvLine(head(lines))), map((line) => map((s_1) => s_1.trim(), parseCsvLine(line)), tail(lines))];
    }
    else {
        return [empty(), empty()];
    }
}

function autoDetectMapping(headers) {
    const findIndex = (candidates) => tryFindIndex((h) => {
        const lower = replace(replace(h.toLowerCase(), " ", ""), "_", "");
        return exists((c) => (lower.indexOf(c) >= 0), candidates);
    }, headers);
    return new ColumnMapping(findIndex(ofArray(["firstname", "first", "forename", "givenname"])), findIndex(ofArray(["lastname", "last", "surname", "familyname"])), findIndex(ofArray(["gender", "sex"])), findIndex(ofArray(["age", "agecategory", "agegroup"])), findIndex(ofArray(["title", "honorific"])), findIndex(ofArray(["diet", "dietary", "dietarynotes", "food", "allergy"])), findIndex(ofArray(["dietarytags", "dietarytag"])), choose((tupledArg) => {
        const lower_1 = replace(replace(tupledArg[1].toLowerCase(), " ", ""), "_", "");
        if (exists((c_1) => (lower_1.indexOf(c_1) >= 0), ofArray(["tag", "tags", "label"]))) {
            return tupledArg[0];
        }
        else {
            return undefined;
        }
    }, indexed(headers)), findIndex(ofArray(["note", "notes", "comment"])));
}

function mappingDropdown(label, headers, current, onSelect) {
    let elems_1, elems;
    return createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
        children: label,
    }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", (current == null) ? "" : int32ToString(current)], ["onChange", (ev) => {
        let matchValue;
        let outArg = 0;
        matchValue = [tryParse(ev.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
            outArg = (v_1 | 0);
        })), outArg];
        if (matchValue[0]) {
            onSelect(matchValue[1]);
        }
        else {
            onSelect(undefined);
        }
    }], (elems = toList(delay(() => append(singleton(createElement("option", {
        value: "",
        children: t_1(Import_unmapped),
    })), delay(() => collect((matchValue_1) => singleton(createElement("option", {
        value: int32ToString(matchValue_1[0]),
        children: matchValue_1[1],
    })), indexed(headers)))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function tagMappingCheckboxes(label, headers, selected, onToggle) {
    let elems_2, elems_1;
    return createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("label", {
        children: label,
    }), createElement("div", createObj(ofArray([["className", "tag-mapping-checkboxes"], (elems_1 = toList(delay(() => collect((matchValue) => {
        let elems;
        const i = matchValue[0] | 0;
        return singleton(createElement("label", createObj(ofArray([["className", "checkbox-label"], (elems = [createElement("input", {
            type: "checkbox",
            checked: contains(i, selected, {
                Equals: (x, y) => (x === y),
                GetHashCode: numberHash,
            }),
            onChange: (ev) => {
                const _arg = ev.target.checked;
                onToggle(contains(i, selected, {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: numberHash,
                }) ? filter((x_2) => (x_2 !== i), selected) : append_1(selected, singleton_1(i)));
            },
        }), createElement("span", {
            children: matchValue[1],
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    }, indexed(headers)))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function uploadStep(state, currentEventId, dispatch) {
    let elems_8;
    const hasCsvData = length(state.Headers) > 0;
    const hasPasteData = length(state.ParsedGuests) > 0;
    return createElement("div", createObj(singleton_1((elems_8 = toList(delay(() => append(singleton(createElement("h4", {
        className: "mb-1",
        children: t_1(Import_step1),
    })), delay(() => append(singleton(createElement("p", {
        className: "text-muted mb-2",
        children: t_1(Import_uploadPrompt),
    })), delay(() => append(singleton(createElement("input", {
        className: "form-input",
        type: "file",
        accept: ".csv",
        onChange: (e) => {
            const input = e.target;
            const files = input.files;
            if (files.length > 0) {
                const file = files.item(0);
                const reader = new FileReader();
                reader.onload = ((_arg) => {
                    const content = reader.result;
                    const patternInput = parseCsv(content);
                    const headers = patternInput[0];
                    const mapping = autoDetectMapping(headers);
                    dispatch(new Msg(98, [content, headers, patternInput[1]]));
                    dispatch(new Msg(99, [mapping]));
                });
                reader.readAsText(file);
            }
        },
    })), delay(() => {
        let elems, tupledArg;
        return append(hasCsvData ? singleton(createElement("div", createObj(ofArray([["className", "mt-2"], (elems = [createElement("p", {
            className: "text-sm",
            children: (tupledArg = Import_detectedColumns(int32ToString(length(state.Headers)), int32ToString(length(state.Rows))), ta(tupledArg[0], tupledArg[1])),
        }), createElement("button", {
            className: "btn btn-primary mt-1",
            children: t_1(Import_next),
            onClick: (_arg_1) => {
                dispatch(new Msg(100, [new ImportStep(1, [])]));
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton(defaultOf()), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "paste-divider"], (elems_1 = [createElement("span", {
                children: t_1(Import_pasteDivider),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(singleton(createElement("textarea", {
                className: "form-input paste-textarea",
                placeholder: t_1(Import_pastePlaceholder),
                value: state.PasteText,
                onChange: (ev) => {
                    dispatch(new Msg(101, [ev.target.value]));
                },
            })), delay(() => {
                let elems_2, tupledArg_1;
                return append(hasPasteData ? singleton(createElement("div", createObj(ofArray([["className", "mt-2"], (elems_2 = [createElement("p", {
                    className: "text-sm",
                    children: (tupledArg_1 = Import_detectedGuests(int32ToString(length(state.ParsedGuests))), ta(tupledArg_1[0], tupledArg_1[1])),
                }), createElement("button", {
                    className: "btn btn-primary mt-1",
                    children: t_1(Import_next),
                    onClick: (_arg_2) => {
                        dispatch(new Msg(100, [new ImportStep(2, [])]));
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : singleton(defaultOf()), delay(() => {
                    let elems_3;
                    return append(singleton(createElement("div", createObj(ofArray([["className", "paste-divider"], (elems_3 = [createElement("span", {
                        children: t_1(Import_cloneDivider),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                        let elems_7;
                        return singleton(createElement("div", createObj(ofArray([["className", "clone-section"], (elems_7 = toList(delay(() => {
                            let elems_4;
                            const otherEvents = filter((e_1) => (e_1.Id !== currentEventId), state.CloneEvents);
                            return append((isEmpty(otherEvents) && isEmpty(state.CloneEvents)) ? singleton(createElement("button", {
                                className: "btn btn-secondary",
                                children: t_1(Import_cloneSelectEvent),
                                onClick: (_arg_3) => {
                                    dispatch(new Msg(110, []));
                                },
                            })) : (isEmpty(otherEvents) ? singleton(createElement("p", {
                                className: "text-muted text-sm",
                                children: t_1(Import_cloneNoEvents),
                            })) : singleton(createElement("select", createObj(ofArray([["className", "form-input"], ["value", state.CloneSourceEventId], ["onChange", (ev_1) => {
                                dispatch(new Msg(108, [ev_1.target.value]));
                            }], (elems_4 = toList(delay(() => append(singleton(createElement("option", {
                                value: "",
                                children: t_1(Import_cloneSelectEvent),
                            })), delay(() => map_1((ev_2) => createElement("option", {
                                value: ev_2.Id,
                                children: ev_2.Name,
                            }), otherEvents))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))))), delay(() => {
                                let elems_6, elems_5;
                                return (state.CloneSourceEventId !== "") ? singleton(createElement("div", createObj(ofArray([["className", "mt-1"], (elems_6 = [createElement("label", createObj(ofArray([["className", "checkbox-label"], (elems_5 = [createElement("input", {
                                    type: "checkbox",
                                    checked: state.CloneIncludeRelationships,
                                    onChange: (ev_3) => {
                                        const _arg_4 = ev_3.target.checked;
                                        dispatch(new Msg(109, []));
                                    },
                                }), createElement("span", {
                                    children: t_1(Import_cloneIncludeRelationships),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("button", {
                                    className: "btn btn-primary mt-1",
                                    children: state.IsImporting ? t_1(Import_cloning) : t_1(Import_cloneButton),
                                    disabled: state.IsImporting,
                                    onClick: (_arg_5) => {
                                        if (!state.IsImporting) {
                                            dispatch(new Msg(112, []));
                                        }
                                    },
                                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : singleton(defaultOf());
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
                    }));
                }));
            }))));
        }));
    })))))))), ["children", reactApi.Children.toArray(Array.from(elems_8))]))));
}

function mapColumnsStep(state, dispatch) {
    let elems_2, elems, elems_1;
    const m = state.Mapping;
    const setMapping = (newMapping) => {
        dispatch(new Msg(99, [newMapping]));
    };
    return createElement("div", createObj(singleton_1((elems_2 = [createElement("h4", {
        className: "mb-1",
        children: t_1(Import_step2),
    }), createElement("div", createObj(ofArray([["className", "import-mapping-grid"], (elems = [mappingDropdown(t_1(Guests_firstName), state.Headers, m.FirstName, (v) => {
        setMapping(new ColumnMapping(v, m.LastName, m.Gender, m.AgeCategory, m.Title, m.DietaryNotes, m.DietaryTags, m.Tags, m.Notes));
    }), mappingDropdown(t_1(Guests_lastName), state.Headers, m.LastName, (v_1) => {
        setMapping(new ColumnMapping(m.FirstName, v_1, m.Gender, m.AgeCategory, m.Title, m.DietaryNotes, m.DietaryTags, m.Tags, m.Notes));
    }), mappingDropdown(t_1(Guests_gender), state.Headers, m.Gender, (v_2) => {
        setMapping(new ColumnMapping(m.FirstName, m.LastName, v_2, m.AgeCategory, m.Title, m.DietaryNotes, m.DietaryTags, m.Tags, m.Notes));
    }), mappingDropdown(t_1(Guests_age), state.Headers, m.AgeCategory, (v_3) => {
        setMapping(new ColumnMapping(m.FirstName, m.LastName, m.Gender, v_3, m.Title, m.DietaryNotes, m.DietaryTags, m.Tags, m.Notes));
    }), mappingDropdown(t_1(Guests_title), state.Headers, m.Title, (v_4) => {
        setMapping(new ColumnMapping(m.FirstName, m.LastName, m.Gender, m.AgeCategory, v_4, m.DietaryNotes, m.DietaryTags, m.Tags, m.Notes));
    }), mappingDropdown(t_1(Guests_dietary), state.Headers, m.DietaryNotes, (v_5) => {
        setMapping(new ColumnMapping(m.FirstName, m.LastName, m.Gender, m.AgeCategory, m.Title, v_5, m.DietaryTags, m.Tags, m.Notes));
    }), mappingDropdown(t_1(Guests_dietaryTags), state.Headers, m.DietaryTags, (v_6) => {
        setMapping(new ColumnMapping(m.FirstName, m.LastName, m.Gender, m.AgeCategory, m.Title, m.DietaryNotes, v_6, m.Tags, m.Notes));
    }), tagMappingCheckboxes(t_1(Guests_tags), state.Headers, m.Tags, (v_7) => {
        setMapping(new ColumnMapping(m.FirstName, m.LastName, m.Gender, m.AgeCategory, m.Title, m.DietaryNotes, m.DietaryTags, v_7, m.Notes));
    }), mappingDropdown(t_1(Guests_notes), state.Headers, m.Notes, (v_8) => {
        setMapping(new ColumnMapping(m.FirstName, m.LastName, m.Gender, m.AgeCategory, m.Title, m.DietaryNotes, m.DietaryTags, m.Tags, v_8));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "flex gap-sm mt-2"], (elems_1 = [createElement("button", {
        className: "btn btn-secondary",
        children: t_1(Import_back),
        onClick: (_arg) => {
            dispatch(new Msg(100, [new ImportStep(0, [])]));
        },
    }), createElement("button", {
        className: "btn btn-primary",
        children: t_1(Import_next),
        disabled: (m.FirstName == null) ? true : (m.LastName == null),
        onClick: (_arg_1) => {
            dispatch(new Msg(100, [new ImportStep(2, [])]));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

function previewCsvStep(state, dispatch) {
    let elems_3;
    const m = state.Mapping;
    const previewRows = truncate(5, state.Rows);
    const getCol = (row, idx) => {
        if (idx == null) {
            return "-";
        }
        else if (idx < length(row)) {
            const i_1 = idx | 0;
            return item_1(i_1, row);
        }
        else {
            return "-";
        }
    };
    return createElement("div", createObj(singleton_1((elems_3 = toList(delay(() => append(singleton(createElement("h4", {
        className: "mb-1",
        children: t_1(Import_step3),
    })), delay(() => {
        let matchValue;
        return append((matchValue = state.Error, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
            className: "error-message",
            children: matchValue,
        }))), delay(() => append(singleton(createElement("p", {
            className: "text-sm mb-1",
            children: t_1(Import_previewRows),
        })), delay(() => {
            let elems_1, children_2, children, children_8;
            return append(singleton(createElement("table", createObj(ofArray([["className", "data-table"], (elems_1 = [(children_2 = singleton_1((children = ofArray([createElement("th", {
                children: t_1(Guests_firstName),
            }), createElement("th", {
                children: t_1(Guests_lastName),
            }), createElement("th", {
                children: t_1(Guests_gender),
            }), createElement("th", {
                children: t_1(Guests_age),
            }), createElement("th", {
                children: t_1(Guests_tags),
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children)),
            }))), createElement("thead", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            })), (children_8 = toList(delay(() => map_1((row_2) => {
                let children_4, tagText, row_1, idxs, merged, elems;
                const children_6 = ofArray([createElement("td", {
                    children: getCol(row_2, m.FirstName),
                }), createElement("td", {
                    children: getCol(row_2, m.LastName),
                }), createElement("td", {
                    children: getCol(row_2, m.Gender),
                }), createElement("td", {
                    children: getCol(row_2, m.AgeCategory),
                }), (children_4 = singleton_1((tagText = ((row_1 = row_2, (idxs = m.Tags, isEmpty(idxs) ? "-" : ((merged = join(", ", choose((i_2) => {
                    if ((i_2 < length(row_1)) && (item_1(i_2, row_1).trim() !== "")) {
                        return item_1(i_2, row_1).trim();
                    }
                    else {
                        return undefined;
                    }
                }, idxs)), (merged === "") ? "-" : merged))))), ((tagText === "-") ? true : (tagText.trim() === "")) ? "-" : createElement("span", createObj(ofArray([["className", "tag-badges-preview"], (elems = toList(delay(() => collect((tag) => {
                    const t = tag.trim();
                    return (t !== "") ? singleton(badge(t)) : empty_1();
                }, split(tagText, [","], undefined, 0)))), ["children", reactApi.Children.toArray(Array.from(elems))])]))))), createElement("td", {
                    children: reactApi.Children.toArray(Array.from(children_4)),
                }))]);
                return createElement("tr", {
                    children: reactApi.Children.toArray(Array.from(children_6)),
                });
            }, previewRows))), createElement("tbody", {
                children: reactApi.Children.toArray(Array.from(children_8)),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let tupledArg;
                return append(singleton(createElement("p", {
                    className: "text-sm mt-1 text-muted",
                    children: (tupledArg = Import_totalRows(int32ToString(length(state.Rows))), ta(tupledArg[0], tupledArg[1])),
                })), delay(() => {
                    let elems_2;
                    return singleton(createElement("div", createObj(ofArray([["className", "flex gap-sm mt-2"], (elems_2 = [createElement("button", {
                        className: "btn btn-secondary",
                        children: t_1(Import_back),
                        disabled: state.IsImporting,
                        onClick: (_arg) => {
                            dispatch(new Msg(100, [new ImportStep(1, [])]));
                        },
                    }), createElement("button", {
                        className: "btn btn-primary",
                        children: state.IsImporting ? t_1(Import_importing) : t_1(Import_importButton),
                        disabled: state.IsImporting,
                        onClick: (_arg_1) => {
                            if (!state.IsImporting) {
                                dispatch(new Msg(106, []));
                            }
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                }));
            }));
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))]))));
}

function genderOptions() {
    return ofArray([[GenderModule_toInt(new Gender(3, [])), t_1(Import_genderUnspecified)], [GenderModule_toInt(new Gender(0, [])), t_1(Enum_Gender_male)], [GenderModule_toInt(new Gender(1, [])), t_1(Enum_Gender_female)], [GenderModule_toInt(new Gender(2, [])), t_1(Enum_Gender_nonbinary)]]);
}

function previewPasteStep(state, dispatch) {
    let elems_8;
    const guests = state.ParsedGuests;
    const swapped = state.NamesSwapped;
    return createElement("div", createObj(singleton_1((elems_8 = toList(delay(() => append(singleton(createElement("h4", {
        className: "mb-1",
        children: t_1(Import_step3),
    })), delay(() => {
        let matchValue;
        return append((matchValue = state.Error, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
            className: "error-message",
            children: matchValue,
        }))), delay(() => {
            let elems_1, elems;
            return append(singleton(createElement("div", createObj(ofArray([["className", "mb-2"], (elems_1 = [createElement("label", createObj(ofArray([["className", "checkbox-label"], (elems = [createElement("input", {
                type: "checkbox",
                checked: swapped,
                onChange: (ev) => {
                    const _arg = ev.target.checked;
                    dispatch(new Msg(102, []));
                },
            }), createElement("span", {
                children: t_1(Import_swapNames),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return append(singleton(createElement("div", createObj(ofArray([["className", "paste-bulk-tags"], (elems_2 = [createElement("label", {
                    children: t_1(Import_bulkTagsLabel),
                }), createElement("input", {
                    className: "form-input",
                    type: "text",
                    placeholder: t_1(Import_bulkTagsPlaceholder),
                    value: state.BulkImportTags,
                    onChange: (ev_1) => {
                        dispatch(new Msg(103, [ev_1.target.value]));
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let tupledArg;
                    return append(singleton(createElement("p", {
                        className: "text-sm mb-1",
                        children: (tupledArg = Import_totalGuests(int32ToString(length(guests))), ta(tupledArg[0], tupledArg[1])),
                    })), delay(() => {
                        let elems_6, elems_5, children_2, children, children_8;
                        return append(singleton(createElement("div", createObj(ofArray([["className", "paste-preview-scroll"], (elems_6 = [createElement("table", createObj(ofArray([["className", "data-table"], (elems_5 = [(children_2 = singleton_1((children = ofArray([createElement("th", {
                            children: t_1(Guests_title),
                        }), createElement("th", {
                            children: t_1(Guests_firstName),
                        }), createElement("th", {
                            children: t_1(Guests_lastName),
                        }), createElement("th", {
                            children: t_1(Guests_gender),
                        }), createElement("th", {
                            children: t_1(Guests_tags),
                        })]), createElement("tr", {
                            children: reactApi.Children.toArray(Array.from(children)),
                        }))), createElement("thead", {
                            children: reactApi.Children.toArray(Array.from(children_2)),
                        })), (children_8 = toList(delay(() => collect((i) => {
                            let elems_4, g, g_1, children_4, matchValue_1, elems_3, children_6;
                            const g_2 = item_1(i, guests);
                            return singleton(createElement("tr", createObj(ofArray([["key", int32ToString(i)], (elems_4 = [createElement("td", {
                                children: g_2.Title,
                            }), createElement("td", {
                                children: (g = g_2, swapped ? g.LastName : g.FirstName),
                            }), createElement("td", {
                                children: (g_1 = g_2, swapped ? g_1.FirstName : g_1.LastName),
                            }), (children_4 = singleton_1(createElement("select", createObj(ofArray([["className", "paste-cell-select"], ["value", (matchValue_1 = g_2.Gender, (matchValue_1 == null) ? int32ToString(GenderModule_toInt(new Gender(3, []))) : int32ToString(matchValue_1))], ["onChange", (ev_2) => {
                                let matchValue_2;
                                let outArg = 0;
                                matchValue_2 = [tryParse(ev_2.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_3) => {
                                    outArg = (v_3 | 0);
                                })), outArg];
                                if (matchValue_2[0]) {
                                    dispatch(new Msg(105, [i, matchValue_2[1]]));
                                }
                            }], (elems_3 = toList(delay(() => collect((matchValue_3) => singleton(createElement("option", {
                                value: int32ToString(matchValue_3[0]),
                                children: matchValue_3[1],
                            })), genderOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), createElement("td", {
                                children: reactApi.Children.toArray(Array.from(children_4)),
                            })), (children_6 = singleton_1(createElement("input", {
                                className: "paste-cell-input",
                                type: "text",
                                value: g_2.Tags,
                                placeholder: (state.BulkImportTags.trim() !== "") ? state.BulkImportTags.trim() : "",
                                onChange: (ev_3) => {
                                    dispatch(new Msg(104, [i, ev_3.target.value]));
                                },
                            })), createElement("td", {
                                children: reactApi.Children.toArray(Array.from(children_6)),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                        }, rangeDouble(0, 1, length(guests) - 1)))), createElement("tbody", {
                            children: reactApi.Children.toArray(Array.from(children_8)),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                            let elems_7;
                            return singleton(createElement("div", createObj(ofArray([["className", "flex gap-sm mt-2"], (elems_7 = [createElement("button", {
                                className: "btn btn-secondary",
                                children: t_1(Import_back),
                                disabled: state.IsImporting,
                                onClick: (_arg_1) => {
                                    dispatch(new Msg(100, [new ImportStep(0, [])]));
                                },
                            }), createElement("button", {
                                className: "btn btn-primary",
                                children: state.IsImporting ? t_1(Import_importing) : t_1(Import_importButton),
                                disabled: state.IsImporting,
                                onClick: (_arg_2) => {
                                    if (!state.IsImporting) {
                                        dispatch(new Msg(106, []));
                                    }
                                },
                            })], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
                        }));
                    }));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_8))]))));
}

function previewStep(state, dispatch) {
    if (length(state.ParsedGuests) > 0) {
        return previewPasteStep(state, dispatch);
    }
    else {
        return previewCsvStep(state, dispatch);
    }
}

export function view(state, currentEventId, dispatch) {
    let elems_2;
    return createElement("div", createObj(ofArray([["className", "import-wizard card"], (elems_2 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "flex items-center justify-between mb-2"], (elems = [createElement("h3", {
            children: t_1(Import_title),
        }), createElement("button", {
            className: "btn btn-sm btn-secondary",
            children: t_1(Import_cancel),
            onClick: (_arg) => {
                dispatch(new Msg(97, []));
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "import-steps mb-2"], (elems_1 = toList(delay(() => collect((matchValue) => singleton(createElement("span", {
                className: equals(matchValue[0], state.Step) ? "import-step active" : "import-step",
                children: matchValue[1],
            })), [[new ImportStep(0, []), t_1(Import_stepUpload)], [new ImportStep(1, []), t_1(Import_stepMap)], [new ImportStep(2, []), t_1(Import_stepImport)]]))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                const matchValue_1 = state.Step;
                return (matchValue_1.tag === 1) ? singleton(mapColumnsStep(state, dispatch)) : ((matchValue_1.tag === 2) ? singleton(previewStep(state, dispatch)) : singleton(uploadStep(state, currentEventId, dispatch)));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

